<script>
// Aussteller-Kontaktempfehlungen: exhibitor-side recommendation list (wiki §29, 6.5).
// Without companyId it shows a company picker (accepted exhibitor members),
// with companyId the recommended visitors of that company.
import ExhibitorVisitorRecommendations from '../components/recommendation/exhibitor-visitor-recommendations.vue'
import DefaultLayout from '@/components/DefaultLayout.vue'

export default {
  name: 'ExhibitorRecommendationsView',
  components: { ExhibitorVisitorRecommendations, DefaultLayout },
  props: {
    companyId: { type: String, default: '' },
  },
}
</script>

<template>
  <default-layout>
    <nav class="nav navbar fixed-top bg-white px-2">
      <div class="nav-item">
        <button @click.prevent="$router.back()" class="btn btn-outline">
          <i class="fas fa-chevron-left"></i></button>
      </div>
      <div class="navbar-brand text-truncate flex-fill mb-0">
        <b>Aussteller-Kontaktempfehlungen</b>
      </div>
    </nav>

    <div class="container-fluid mt-2 py-5">
      <exhibitor-visitor-recommendations :company-id="companyId" />
    </div>
  </default-layout>
</template>
